import { FloorLayers } from "@iko-design-center/shared";
import { MultiSelectOption } from "../../components/common/MultiSelect";

export type DownloadState = {
  technicalFiche: {
    floorInsulation: boolean;
    floorScreed: boolean;
  };
  DOP: {
    floorInsulation: boolean;
    floorScreed: boolean;
  };
  thermalCalculation: boolean;
  specifications: boolean;
  BIMFile: boolean;
  screenshots: boolean;
  processingGuideline: boolean;
};

export const initialDownloadState: DownloadState = {
  technicalFiche: {
    floorInsulation: false,
    floorScreed: false,
  },
  DOP: {
    floorInsulation: false,
    floorScreed: false,
  },
  thermalCalculation: false,
  specifications: false,
  BIMFile: false,
  screenshots: false,
  processingGuideline: false,
};

export const allSelectedDownloadState: DownloadState = {
  technicalFiche: {
    floorInsulation: true,
    floorScreed: true,
  },
  DOP: {
    floorInsulation: true,
    floorScreed: true,
  },
  thermalCalculation: true,
  specifications: true,
  BIMFile: true,
  screenshots: true,
  processingGuideline: true,
};

export type LayerState = {
  [key in FloorLayers]: boolean;
};

export function getLayerOptions({
  t,
  state,
}: {
  t: any;
  state: LayerState;
}): MultiSelectOption<FloorLayers>[] {
  return [
    {
      label: t("modal.download.insulation"),
      value: FloorLayers.floorInsulation,
      checked: state.floorInsulation,
    },
  ];
}
